import { PropsWithChildren } from 'react'

import { FunctionKey } from '@/constants/function-key'
import { selectMineFunctionKeys } from '@/redux/function-permission-selector'
import { useAppSelector } from '@/redux/utils'

export interface FunctionPermissionProps extends PropsWithChildren {
  functionKey?: FunctionKey
  functionKeys?: FunctionKey[]
}

export default function FunctionPermission({
  functionKey,
  functionKeys,
  children,
}: FunctionPermissionProps) {
  const mineFunctionKeys = useAppSelector(selectMineFunctionKeys)

  if (functionKey) {
    return mineFunctionKeys.includes(functionKey) ? children : null
  }

  if (functionKeys) {
    return functionKeys.every((key) => !mineFunctionKeys.includes(key)) ? null : children
  }

  return null
}
